"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import AngleRightBold from "@/icons/angleRightBold.svg";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { getTranslation } from "@/i18n/get-translation";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import SingleFeaturePost from "@components/single-feature-post/single-feature-post";
import { getAllNews } from "@/services/news.service";
import { INewsResponse } from "@/types/news.type";

interface INewsFeaturePost {
  locale: string;
}
const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
export default function NewsFeaturePost({ locale }: INewsFeaturePost) {
  const t = getTranslation(locale, "featurePosts");
  const j = getTranslation(locale, "innerSubCategories");
  const searchParams = useSearchParams();
  const [blogs, setBlogs] = useState<INewsResponse>(init);
  const handleFetchBlogs = useCallback(
    (blogCategory: string | null) => {
      const lang =
        locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;
      getAllNews(lang, blogCategory !== j("all") ? blogCategory : null, true)
        .then((res: INewsResponse) => {
          setBlogs(res);
        })
        .catch(console.log);
    },
    [locale, j]
  );
  useEffect(() => {
    const search = searchParams.get("category");
    if (search) {
      handleFetchBlogs(search);
    } else {
      handleFetchBlogs(j("all"));
    }
  }, [searchParams]);

  return (
    <div className="lg:pb-12 pb-6 w-full flex relative">
      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1.1}
        navigation={{
          nextEl: ".next-slide",
          prevEl: ".prev-slide",
        }}
        pagination={true}
        className="relative featureSwiper !px-20 max-md:!px-7"
        breakpoints={{
          992: {
            slidesPerView: "auto",
            pagination: false,
          },
        }}
      >
        {blogs.data.map((blog, key) => (
          <SwiperSlide key={key}>
            {blog.attributes.poster && (
              <SingleFeaturePost
                href={`/${locale}/news/${blog.id}`}
                title={blog.attributes.title}
                imgUrl={`${
                  blog?.attributes?.poster?.data
                    ? blog?.attributes?.poster?.data?.attributes?.url
                    : "/images/no-image.jpg"
                }`}
              />
            )}
          </SwiperSlide>
        ))}
        <button className="prev-slide absolute top-2/4 -translate-y-2/4 z-20 [&.swiper-button-disabled]:opacity-0 left-[6.375rem] max-md:hidden">
          <div className="relative">
            <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
            <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 -translate-1/2 rotate-180" />
          </div>
        </button>
        <button className="next-slide absolute top-2/4 -translate-y-2/4 z-20 [&.swiper-button-disabled]:opacity-0 right-[6.375rem] max-md:hidden">
          <div className="relative">
            <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
            <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 transform-[translate(-50%,-50%)]" />
          </div>
        </button>
      </Swiper>
    </div>
  );
}
